import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

import {MySortButtonStatesEnum} from '../../../../enums/my-sort-button-states.enum';
import {ProjectsListItemModel} from '../../../../models/projects-list-item.model';
import {MyProjectsTableRowActionEnum} from '../../../../enums/my-project-table-row-action.enum';

@Component({
    selector: 'app-projects-table',
    templateUrl: './projects-table.component.html',
    styleUrls: ['./projects-table.component.scss']
})
export class ProjectsTableComponent implements OnInit {

    @Input() projects: ProjectsListItemModel[];
    @Output() public headerSortBtnClicked = new EventEmitter<{ columnId: string; state: MySortButtonStatesEnum }>();
    @Output() public projectTableRowActionsMenuClicked =
        new EventEmitter<{ projectsListItem: ProjectsListItemModel, actionId: MyProjectsTableRowActionEnum }>();

    public tableColumnsLabels = [
        {label: 'Projektname / Firma', propertyToSort: 'name'},
        {label: 'Ort', propertyToSort: 'companyZip'},
        {label: 'Geräte', propertyToSort: 'requestedProductsTotalCount'},
        {label: 'Projektzeitraum', propertyToSort: 'rolloutStart', defaultState: MySortButtonStatesEnum.ASCENT},
        {label: 'Gültig bis', propertyToSort: 'validityOfQuotation'},
        {label: 'Projektstatus', propertyToSort: 'status'}
    ];

    constructor() {
    }

    public ngOnInit() {
    }

    public onHeaderSortBtnClicked($event: { columnId: string; state: MySortButtonStatesEnum }) {
        this.headerSortBtnClicked.emit($event);
    }


    public onProjectActionsMenuClicked($event: { projectListItem: ProjectsListItemModel, actionId: MyProjectsTableRowActionEnum }) {
        this.projectTableRowActionsMenuClicked.emit({
            projectsListItem: $event.projectListItem,
            actionId: $event.actionId
        });
    }
}
